import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';
import LoadingPageText from '../../components/common/Loading/LoadingPageText';
import SearchFilters from './NPASearchFilters';
import { useFetchNonPatientActivitiesList } from '../../actions/areas/nonPatientActivities/fetchNonPatientActivities';
import { eventHandlers } from './NPAHandler';
import { tableSettings } from './NPATableSettings';
import ConfirmationDialog from '../../components/common/ConfirmationDialog/ConfirmationDialog';
import { getDateForApi } from '../../utils/dates';

export default function NonPatientActivitiesPage() {
  document.title = 'Non Patient Activities';

  const [state, setState] = useState({
    forceReload: false,
    selectedOrgUnits: [],
    selectedClinicians: [],
    dateFrom: null,
    dateTo: null,
    currentPage: 1,
    pageSize: 15,
    sortColumn: 'DateCreated',
    sortDirection: 'desc',
    showDeleteNpaConfirmation: false,
    showEditNpaConfirmation: false,
    currentItemId: 0,
  });

  const model = {
    OrgUnitIds: state.selectedOrgUnits.map(unit => unit.id),
    ClinicianIds: state.selectedClinicians.map(c => c.id),
    DateFrom: getDateForApi(state.dateFrom),
    DateTo: getDateForApi(state.dateTo),
    pageSize: state.pageSize,
    currentPage: state.currentPage,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
  };

  const { data, isDataLoading, isTableDataLoading } = useFetchNonPatientActivitiesList(model, state.forceReload);

  const events = eventHandlers(state, setState);
  const settings = tableSettings({
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn: state.sortColumn,
    sortDirection: state.sortDirection,
    eventHandlers: events,
    isTableDataLoading,
    currentItemId: state.currentItemId,
  });

  if (isDataLoading)
    return (
      <LoadingPageText showHeader={false}>
        Wait a moment while we gather Non-Patient Activties list info...
      </LoadingPageText>
    );

  return (
    <React.Fragment>
      <SearchFilters onSubmit={events.onFiltersChange} events={events} />
      <div className="page-content-wrapper">
        <MUIDataTable
          title={settings.name}
          data={data.nonPatientActivities}
          columns={settings.columns}
          options={settings.options}
        />
      </div>
      <ConfirmationDialog
        open={state.showDeleteNpaConfirmation}
        handleCancel={events.handleDeleteNpaCancel}
        handleConfirm={events.handleDeleteNpaConfirm}
        title={events.locale.getMsg('deleteNonPatientActivityConformationTitle')}
        text={events.locale.getMsg('deleteNonPatientActivityConformationText')}
      />
      <ConfirmationDialog
        isInformational
        open={state.showEditNpaConfirmation}
        handleCancel={() => setState({ ...state, showEditNpaConfirmation: false })}
        title={events.locale.getMsg('editMonthlyNonPatientActivityConformationTitle')}
        text={events.locale.getMsg('editMonthlyNonPatientActivityConformationText')}
      />
    </React.Fragment>
  );
}
